import { ButtonBase, Tab, Tabs, styled as muiStyled } from '@mui/material'

export const MyTimersItemsListingContainer = muiStyled('div')(
  ({ theme }) => `
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content:center;
      gap: 10px;
      padding: 10px;
      //this is where you can change the grid layout.
  `,
)

export const TimerListingTabsContainer = muiStyled(Tabs)(
  ({ theme }) => `
  margin: 10px 10px;
  .MuiTabs-indicator {
    background-color: #a5a6ff !important; 
  }
  .Mui-selected { 
    color: #a5a6ff !important;
  }
  .MuiTabs-flexContainer{
    justify-content: center;
  }
`,
)

export const TimerListingTab = muiStyled(Tab)(
  ({ theme }) => `
  color: #fff;
  &:disabled {
    color: #ffffff73 !important;
  }
  .Mui-disabled {
    color: #ffffff73 !important;
  }
  // background: #000;
`,
)

export const AddTimerButton = muiStyled(ButtonBase)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 6px 10px;
    border-radius: 5px;
    background-color: #7B49E5;
    color: #fff;
    border: 1px solid transparent;
    flex-shrink: 0;
    transition: all 400ms ${theme.transitions.easing.quickInOut};
    .btn-txt {
      display: none;
      margin: 0;
      @media (min-width: 576px) {
        display: block;
      }
    }
    &:disabled {
      background: #958fa3;
      color: #000;
    }
    &:hover {
      background: #6524f0;
      border: 1px solid #ffffff2b;
    }
`,
)

export const TimersListingLoadingOverlay = muiStyled('div')(
  ({ theme }) => `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  padding: 20px 0px 0px 0px;
  justify-content: center;
  backdrop-filter: blur(13.1px);
  background: #000000b3;
  z-index: 2;
`,
)
